import React from 'react';

class Loader extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="loader-wrapper">
        <div className="bookshelf_wrapper">
          <ul className="books_list">
            <li className="book_item first" />
            <li className="book_item second" />
            <li className="book_item third" />
            <li className="book_item fourth" />
            <li className="book_item fifth" />
            <li className="book_item sixth" />
          </ul>
          <div className="shelf" />
        </div>
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/js/components/Loader.js